module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAAbFBMVEXOICjPIijQIifQKSfQKifSMibTNybUOyXYSSTZTSTZTiPbViPdXCHdXSHdYCLdYSLfYyDhciDjex/kex/mhB7qlRzqlhzsoBvuphvuqBvuqRrvrRryuBjzuxn0vxj1xBj3zBf3zRf41Bb51haBH2CZAAAAs0lEQVR42o2TWQ6DMAxEE/ay07CVLcDc/44VwQ0SqJL9Nda8KBrHEfEAAI0nbGlAX53XHP4QC3GiS2StDuhsEy0/TBC6K0mdAt4kpdotdqFjcOoESE4VjDeM0LUwygd8I4qVsAdKmbSmFBZ7oiZT15kUhP1BeyWdsnSk6u/YNg9tXeVx6BKaTsCUEuaGr7yq28+8CdiiI9mhM7Ivlw2yr+aE4Y+HP3D+E/KXgr9m7MVlf4UvdJMinRFp4TsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/mk.png
// module id = 878
// module chunks = 0